import { defineStyle } from '@chakra-ui/react';

export const unstyledVariant = defineStyle({
  border: 'none',
  backgroundColor: 'transparent',
  paddingInline: 'none',
});
